export const settings = {
    NODE_ENV: process.env.REACT_APP_NODE_ENV,
    HYGRAPH_CONTENT_API_URL: process.env.REACT_APP_HYGRAPH_CONTENT_API_URL,
    HYGRAPH_ACCESS_TOKEN: process.env.REACT_APP_HYGRAPH_ACCESS_TOKEN,
    BASE_PATH: process.env.REACT_APP_BASE_PATH,
};